import { RECIPE_CATEGORIES } from './categories.js';
import { SEASONS } from './seasons.js';
export const TYPE_FILTERS = [
    { key: 'recipe', labelKey: 'recipes.recipes' },
    { key: 'dish', labelKey: 'recipes.dishes' },
];
export const CATEGORY_FILTERS = RECIPE_CATEGORIES.map((c) => ({
    key: c,
    labelKey: `categories.${c}`,
}));
export const SEASON_FILTERS = SEASONS.map((s) => ({
    key: s,
    labelKey: `seasons.${s}`,
}));
/**
 * Spelled as the design system spells a duration — `1 h`, the unit apart from
 * its number — with no-break spaces, so « < 1 h » never leaves its « h » on the
 * next line of a narrow chip.
 */
export const TIME_FILTERS = [
    { key: 'lt15', label: '<\u00a015\u00a0min', max: 15 },
    { key: 'lt30', label: '<\u00a030\u00a0min', max: 30 },
    { key: 'lt60', label: '<\u00a01\u00a0h', max: 60 },
    { key: 'gt60', label: '>\u00a01\u00a0h', min: 60 },
];
/**
 * The orders the carnet proposes, in the order it proposes them.
 *
 * They are phrased as a cook asks for them — « temps, du plus court », « pas
 * cuisinées depuis longtemps » — rather than as the column they sort on. The
 * server knows a few more (`recent`, `name-desc`, `popularity`); they are not
 * offered here because six lines is already a menu one reads rather than
 * scans.
 */
export const SORT_OPTIONS = [
    { key: 'name-asc', labelKey: 'recipes.sortNameAsc' },
    { key: 'time-asc', labelKey: 'recipes.sortTimeAsc' },
    { key: 'last-used', labelKey: 'recipes.sortLastUsed' },
    { key: 'oldest-used', labelKey: 'recipes.sortOldestUsed' },
    { key: 'favorites-first', labelKey: 'recipes.sortFavoritesFirst' },
    // Last while it is a promise: the head of a menu is for an order that works.
    { key: 'relevance', labelKey: 'recipes.sortRelevance', pending: true },
];
/**
 * What the carnet sorts by until « pertinence » exists.
 *
 * Alphabetical rather than the server's own `recent` default: the order shown
 * as selected has to be one the menu actually names, and of the five that
 * work it is the only one that does not depend on what the family has cooked.
 */
export const DEFAULT_SORT = 'name-asc';
export const FAVORITES_FILTER = {
    key: 'favorites',
    labelKey: 'recipes.favorites',
};
/**
 * « De saison » — what is in season this month, by the season the family typed
 * or, failing that, by its ingredients. A shortcut beside Favoris rather than
 * a fifth season: it follows the calendar, the four seasons do not.
 */
export const IN_SEASON_FILTER = {
    key: 'in-season',
    labelKey: 'recipes.inSeason',
};
export const RECIPE_FILTER_GROUPS = [
    { key: 'type', titleKey: 'recipes.filterType', kind: 'filter', options: TYPE_FILTERS },
    {
        key: 'category',
        titleKey: 'recipes.filterCategory',
        kind: 'filter',
        options: CATEGORY_FILTERS,
    },
    { key: 'time', titleKey: 'recipes.filterTime', kind: 'time', options: TIME_FILTERS },
    { key: 'season', titleKey: 'recipes.filterSeason', kind: 'filter', options: SEASON_FILTERS },
];
/**
 * Which values of one criterion the selected chips name, resolved from the
 * keys alone.
 *
 * Every selected value is kept: the chips of one group are alternatives, and
 * keeping only the first would draw two chips as on while filtering by one.
 */
function selectedIn(options, keys) {
    return options.filter((f) => keys.includes(f.key)).map((f) => f.key);
}
export function recipeFilterTypes(keys) {
    return selectedIn(TYPE_FILTERS, keys);
}
export function recipeFilterCategories(keys) {
    return selectedIn(CATEGORY_FILTERS, keys);
}
export function recipeFilterSeasons(keys) {
    return selectedIn(SEASON_FILTERS, keys);
}
//# sourceMappingURL=recipe-filters.js.map